// extracted by mini-css-extract-plugin
export default {"userInfoBox":"yWYB6jJJEDP_Ndbb1bzu","userInfo":"tA5HtoWDVvYVVlg5x5i3"};